import { render, staticRenderFns } from "./RejectedMenber.vue?vue&type=template&id=1e20f36c&scoped=true&"
import script from "./RejectedMenber.vue?vue&type=script&lang=js&"
export * from "./RejectedMenber.vue?vue&type=script&lang=js&"
import style0 from "./RejectedMenber.vue?vue&type=style&index=0&id=1e20f36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e20f36c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VContainer,VDataTable,VForm,VIcon,VToolbar})
